import React, { useState, useEffect } from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import { Fonts } from '@projectK/constants';
import AppCard from '@projectK/components/AppCard';
import jwtAxios from '@projectK/services/auth/JWT';
import { useAuthUser } from '@projectK/hooks/AuthHooks';

const ProfileinfoCard = () => {
  const { user } = useAuthUser();

  const [settings, setSettings] = useState(null);

  const fetchSettings = async () => {
    try {
      const response = await jwtAxios.get(`/users/${user.id}`);
      setSettings(response.data);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <AppCard>
      <Box className={'profile-info-client-logo'}>
        <Box className={'profile-client-logo'}>
          <Avatar
            sx={{
              width: { xs: 70, lg: 84 },
              height: { xs: 70, lg: 84 },
              cursor: 'pointer',
            }}
            src={settings?.user_profile_pic ? `${process.env.NX_CLOUD_FRONT_URL}/${settings?.user_profile_pic}` : null}
          />

          <Box
            className='profile-name-email'
            sx={{
              ml: 4,
            }}
          >
            <Typography
              sx={{
                fontWeight: Fonts.BOLD,
                fontSize: 18,
              }}
            >
              {settings?.first_name} {settings?.last_name}
            </Typography>
            <Typography
              sx={{
                color: '#000000',
              }}
            >
              {settings?.email}
            </Typography>
            <Typography
              sx={{
                color: '#5c5050',
              }}
            >
              {user?.role[0]}
            </Typography>
          </Box>
        </Box>
        <Box className={'client-logo'}>
          <a href='https://app.coachnow.io/signin' target='#'>
            <img
              src={'/assets/images/CoachNow.png'}
              alt='home_logo'
              style={{ width: '150px' }}
            />
          </a>
          <a href='https://app-v3.teambuildr.com/login' target='#'>
            <img
              src={'/assets/images/Teambuilder.png'}
              alt='home_logo'
              style={{ width: '150px' }}
            />
          </a>
        </Box>
      </Box>
    </AppCard>
  );
};

export default ProfileinfoCard;
